import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#DCD7C9] bg-[#F1EFE7] mt-24">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="font-display text-2xl font-semibold text-[#1A2E24] flex items-center gap-2">
            <span className="inline-block h-3 w-3 rotate-45 bg-[#D35400]" />
            Tool Cool Farm & Homestead Experts
          </div>
          <p className="mt-4 text-[#5C6B64] leading-relaxed max-w-md">
            A Berlin-based contracting firm bridging European craft & American opportunity —
            we help skilled contractors move from Berlin to the United States.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#1A2E24]">Navigate</div>
          <ul className="mt-4 space-y-2 text-sm text-[#5C6B64]">
            <li><Link data-testid="footer-home" className="hover:text-[#1A2E24]" to="/">Home</Link></li>
            <li><Link data-testid="footer-jobs" className="hover:text-[#1A2E24]" to="/jobs">Jobs</Link></li>
            <li><Link data-testid="footer-about" className="hover:text-[#1A2E24]" to="/about">About</Link></li>
            <li><Link data-testid="footer-services" className="hover:text-[#1A2E24]" to="/services">Services</Link></li>
            <li><Link data-testid="footer-contact" className="hover:text-[#1A2E24]" to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#1A2E24]">Berlin Office</div>
          <ul className="mt-4 space-y-3 text-sm text-[#5C6B64]">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 shrink-0" />Torstraße 138, 10119 Berlin, Germany</li>
            <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5 shrink-0" />hello@toolcoolhomestead.com</li>
            <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5 shrink-0" />+49 30 1234 5678</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#DCD7C9]">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-[#5C6B64]">
          <span>© {new Date().getFullYear()} Tool Cool Farm & Homestead Experts</span>
          <span className="tracking-widest uppercase">Berlin → United States</span>
        </div>
      </div>
    </footer>
  );
}
